import React from 'react';
import { formatPhoneNumber } from '../../../utils/phone';

function BasicContactActions({ phone, website, email, phoneField, websiteField, emailField }) {
  if (!phone && !website && !email) {
    return null;
  }

  return (
    <div id="ContactActions" className="space-y-1 text-sm text-black/80">
      {phone ? (
        <p title={`listing field: ${phoneField}`}>
          Call{' '}
          <a data-listing-action="phone" href={`tel:${phone}`} className="underline underline-offset-2 hover:opacity-80">
            {formatPhoneNumber(phone)}
          </a>
        </p>
      ) : null}

      {website ? (
        <p title={`listing field: ${websiteField}`}>
          Website{' '}
          <a
            data-listing-action="website"
            href={website}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2 hover:opacity-80"
          >
            {website}
          </a>
        </p>
      ) : null}

      {email ? (
        <p title={`listing field: ${emailField}`}>
          Email{' '}
          <a href={`mailto:${email}`} className="underline underline-offset-2 hover:opacity-80">
            {email}
          </a>
        </p>
      ) : null}
    </div>
  );
}

export default BasicContactActions;
